import React, { useState } from 'react';
import { Box, Button, Link, Typography } from '@mui/material';
import Input from '../../components/Input';
import logoWhite from '../../assets/images/logo-white.png';
import { recoverPasswordSendMail } from '../../services/users.js';
import { useAlert } from '../../context';
import { AlertError, AlertSuccess } from '../../components/Alerts';
import './index.scss';

const SendTokenPasswordForm = () => {
  const [email, setEmail] = useState('');
  const { setShowSuccess, setShowError } = useAlert();

  const handleSubmit = e => {
    e.preventDefault();
    recoverPasswordSendMail(email).then(
      () => setShowSuccess(true),
      () => setShowError(true)
    );
  };

  return (
    <Box className="auth-layout">
      {/* Painel esquerdo */}
      <Box className="auth-panel-left">
        <img src={logoWhite} alt="HWater" />
        <Typography className="auth-panel-tagline">
          Biblioteca Virtual de Saneamento
        </Typography>
        <Typography className="auth-panel-sub">
          Repositório privado de documentos, normas e publicações relevantes para o setor de saneamento.
        </Typography>
      </Box>

      {/* Painel direito */}
      <Box className="auth-panel-right">
        <Box className="auth-form-inner" component="form" onSubmit={handleSubmit}>
          <Typography className="auth-title">Redefinir senha</Typography>
          <Typography className="auth-subtitle">
            Informe seu e-mail e enviaremos as instruções para redefinir sua senha.
          </Typography>

          <Box sx={{ mb: '16px' }}>
            <Input
              required
              type="email"
              id="email"
              label="Email"
              name="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
            />
          </Box>

          <Button type="submit" variant="contained" className="auth-btn" onClick={handleSubmit}>
            Enviar instruções
          </Button>

          <Box className="auth-links">
            <Link href="/">Voltar para login</Link>
          </Box>
        </Box>

        <AlertError textAlert="Usuário não encontrado." />
        <AlertSuccess textAlert="E-mail de recuperação enviado com sucesso!" />
      </Box>
    </Box>
  );
};

export default SendTokenPasswordForm;
